export class TabsNavigationStyle {
  navigation = 'uk-tab';
  navPosition = 'uk-width-1-1';
  contentPosition = 'uk-width-1-1';
  tabsAlignment = '';
  marginBottom = 'uk-margin-small-bottom';
  navigationColumnWidth = '';
}
